"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_SUBSCHEMA_MAP_SYMBOL = exports.OBJECT_SUBSCHEMA_SYMBOL = exports.UNPATHED_ERRORS_SYMBOL = void 0;
exports.UNPATHED_ERRORS_SYMBOL = Symbol.for('subschemaErrors');
exports.OBJECT_SUBSCHEMA_SYMBOL = Symbol.for('initialSubschema');
exports.FIELD_SUBSCHEMA_MAP_SYMBOL = Symbol.for('subschemaMap');
